import axios from '../../axios/index.js'

export default{
    expenses(){
        return axios.get('notifications/expenses')        
    },
    readComment(data){
        return axios.post('notifications/readComment',data )        
    }
}